import { css, useTheme } from '@fable/theme'
import { useNavigate, useLocation } from 'react-router-dom'
import { BookImage, Button, Text } from '@fable/components'
import { Book } from '@fable/types'
import { LinkToPath } from '../../../../../../types'
import altTag from '../../../../../../utils/altTag'
import { routes } from '../../../../routes'

interface Props {
  book: Book
  customClass?: string
  openBook: () => void
  path: LinkToPath
}

export const PurchasedBook: React.FC<Props> = ({
  book,
  customClass = '',
  openBook,
  path,
}) => {
  const { colors } = useTheme()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { title, authors, cover_image } = book
  const buttonTitle = 'Start reading'
  const tagTitle =
    book.status === 'preview' && pathname === routes.bookshelf ? 'SAMPLE' : null

  return (
    <div
      className={`${customClass} owned`}
      data-testid="purchased-book-component"
      onClick={() => navigate(path)}
    >
      <BookImage
        image={cover_image}
        altTag={altTag.storeBook(book)}
        tagTitle={tagTitle}
      />
      <div className="book-details">
        <div className="top">
          <Text className="book-title" type="subhead" sizing="S" truncate={2}>
            {title}
          </Text>
          <Text
            className="book-author"
            type="body"
            sizing="M"
            color={colors.hurricane}
            truncate={1}
          >
            By {authors[0].name}
          </Text>
        </div>
        <div className="actions">
          <Button
            secondary
            small
            className={css`
              padding: 0 12px;
              white-space: nowrap;
            `}
            width="fit-content"
            onClick={(e) => {
              e.stopPropagation()
              openBook()
            }}
          >
            {buttonTitle}
          </Button>
        </div>
      </div>
    </div>
  )
}
